import * as React from "react";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { Alert } from "@mui/material";
import {
  appDarkBlue,
  appGreen,
  blueBorder,
  borderRadius,
  navbarBlue,
} from "../../Design/SourcesJS/themes";

export default function SavedToast({ text }) {
  let [open, setOpen] = React.useState(true);

  function handleClose() {
    setOpen(false);
  }

  React.useEffect(() => {
    if (!window || !window.history || !document) return;
    window.history.replaceState({}, document.title);
  }, []);

  return (
    <Snackbar
      open={open}
      autoHideDuration={5000}
      onClose={handleClose}
      sx={{
        ".MuiPaper-root": {
          border: blueBorder,
          borderRadius: borderRadius,
          bgcolor: "white",
        },
        ".MuiSvgIcon-root": {
          fill: appDarkBlue,
        },
      }}
    >
      <Alert onClose={handleClose} severity="success" sx={{ width: "100%" }}>
        {text || "Úspěšně uloženo"}
      </Alert>
    </Snackbar>
  );
}
